<template lang="pug">
  div
    el-row.container(type="flex")
      app-card-dashboard(title="Processos com VTN desistente" :content="this.dadosCards.vtnDesistente || '0'" color="red" :style="{'marginLeft': 0}" :marginTop="0")
      app-card-dashboard(title="Processos com VTN em aberto" :content="this.dadosCards.vtnAberto || '0'" color="yellow" :style="{'marginLeft': 0}" :marginTop="0")
      app-card-dashboard(title="Processos com VTN quitada" :content="this.dadosCards.vtnQuitada || '0'" color="#3d9c67" :style="{'marginLeft': 0}" :marginTop="0")
    el-row.container(type="flex")
      card-area(title='Total de VTN a arrecadar' :value="formatValor(this.dadosCards.vtnTotalEmArrecadacao) || 0", :isHa="false")
      card-area(title='Total de VTN arrecadados' :value="formatValor(this.dadosCards.vtnTotalArrecadado) || 0", :isHa="false")
      card-area(title='Total de VTN' :value="formatValor(this.dadosCards.vtnTotal) || 0", :isHa="false")
    el-row.container-grafico
      h3 Gráfico
      abas-grafico(
        @tabChanged='alterarGrafico($event)'
        :abas="abas"
        )
      filtro-vtn(
        @filtrar='filtrar($event)'
        @limpar='limpar()'
        :showNumeroProcesso='true'
      )
      div.container#opcoes-periodo(type="flex" v-if='this.abaAtiva === "PERIODO"')
        div.opcao-periodo#day(@click='changeTipoData("diario")')
          span Diário
        div.opcao-periodo#month(@click='changeTipoData("mensal")')
          span Mensal
        div.opcao-periodo#year(@click='changeTipoData("anual")')
          span Anual
      grafico(
        v-if='showGrafico'
        idDiv="sample"
        :dados="dadosGrafico"
        keyX="dadoNominal"
        keyY="dadoQuantitativo"
        keyText="quantidade"
        :showTituloGrafico="false"
        :tituloX="this.tituloX"
        :tituloY="this.tituloY"
        :cores="this.cores"
        :style="{'box-shadow': '0 2px 12px 0 rgba(0, 0, 0, 0.1)'}"
        :zoom=false
        :switchText="this.switchText"
      )
      el-row.tableContainer(
        v-if='!showGrafico'
        )
        el-table(
          :data='dadosGraficoTabela'
          style="padding: 30px; overflow: auto; height: 400px;"
          )
          el-table-column(
            prop="dadoNominal",
            :label="this.tituloX"
          )
          el-table-column(
            prop="dadoQuantitativo",
            :label="this.tituloY"
          )
      el-row(type="flex")
        el-radio-group(v-model="showGrafico")
          el-radio-button(:label="true") Gráfico
          el-radio-button(:label="false") Tabela
      el-row.container-switch(type="flex")
        span Por quantidade de VTNs
        el-switch(
          v-model="switchValue"
          active-color="#4dd863"
          inactive-color="#a7a7a7"
        )
        span Por Valor do imóvel (em R$)
        el-button(type="primary" @click='exportar')#export-button Exportar

    el-row.container-grafico(style="marginTop: 3%")
      h3 VTNs
      filtro-vtn(
        @filtrar='filtrarProcessos($event)'
        @limpar='limparProcessos()'
        :showNumeroProcesso='true'
      )
      h3(style="marginTop: 1%; marginLeft : 1%") Listagem de VTN
      table-generica(
        :colunas="colunas",
        :dados='processos',
        :botoesAcao="botoesAcao",
        :sortChanged='sortChanged'
      )
      el-row.container-switch(type="flex" style="marginTop: 1%")
        app-paginacao(
          :total="totalProcessos"
          :pagina="pagina",
          @changePage="changePage($event)"
        )
        el-button(type="primary" @click='exportarProcessos')#export-button Exportar

    app-modal(titulo="Visualizar processo" v-if='showModal' @closeModal='showModal = false')
      template(slot="body")
        analise-processo(
          routeListagemName="arrecadacao/relatorios"
          :isVisualizar='true'
          :idProcesso='this.idProcessoSelecionado'
        )

</template>

<script>
import { mapActions } from 'vuex'
import CardArea from '@/screens/arrecadacao/relatorios/components/CardArea'
import AbasGrafico from '@/screens/arrecadacao/relatorios/components/AbasGrafico'
import FiltroVtn from './components/FiltroVtn'
import AppCardDashboard from '@/components/AppCardDashboard'
import AppModal from '@/components/AppModal'
import AppPaginacao from '@/components/AppPaginacao'
import Grafico from '@/screens/demandas/components/Grafico'
import TableGenerica from '@/components/TableGenerica'
import GRAFICO from '@/constants/grafico'
import parametros from '../constants/tipoParametros'
import AnaliseProcesso from '@/screens/arrecadacao/components/AnaliseProcesso'
import domtoimage from 'dom-to-image'
import Util from '@/utils/utils'
import _ from 'lodash'

export default {
  beforeRouteLeave (to, from, next) {
    document.title = 'SiCARF'
    next()
  },

  components: {
    CardArea,
    AppCardDashboard,
    Grafico,
    AbasGrafico,
    FiltroVtn,
    TableGenerica,
    AppPaginacao,
    AppModal,
    AnaliseProcesso
  },

  data () {
    return {
      dadosCards: {},
      dadosGrafico: [],
      dadosGraficoTabela: [],
      tableData: [],
      processos: [],
      showModal: false,
      idProcessoSelecionado: null,
      totalProcessos: 0,
      filtro: parametros.FILTRO_EMPTY,
      filtroProcessos: {
        simplificado: true,
        campoSimplificado: ''
      },
      tipoQuery: parametros.DEFAULT.tipoQuery,
      parametroQuery: parametros.DEFAULT.parametroQuery,
      tituloY: parametros.DEFAULT.tituloY,
      tituloX: parametros.DEFAULT.tituloX,
      cores: GRAFICO.CORES_ARRECADACAO,
      switchValue: parametros.DEFAULT.switchValue,
      abaAtiva: parametros.DEFAULT.abaAtiva,
      showGrafico: parametros.DEFAULT.showGrafico,
      tipoData: parametros.TIPO_DATA.mensal,
      switchText: {
        texto: 'VTNs',
        template: '%{y}'
      },
      colunas: [
        {
          prop: 'processo.numeroProcesso',
          label: 'Processo',
          width: 'auto',
          formatter: Util.formatEmptyRow
        },
        {
          prop: 'processo.cpfCnpjInteressado',
          label: 'CPF/CNPJ do Interessado',
          width: 'auto',
          formatter: Util.formatEmptyRow
        },
        {
          prop: 'processo.nomeRazaoSocialInteressado',
          label: 'Nome/Razão social do Interessado',
          width: 'auto',
          formatter: Util.formatEmptyRow
        },
        {
          prop: 'formaPagamento',
          label: 'Tipo de Pagamento',
          width: 'auto',
          formatter: Util.formatEmptyRow
        },
        {
          prop: 'processo.tipo.nome',
          label: 'Tipo de Processo',
          width: 'auto',
          formatter: Util.formatEmptyRow
        },
        {
          prop: 'proximoVencimento',
          label: 'Próximo vencimento',
          width: 'auto',
          formatter: Util.formatEmptyRow
        },
        {
          prop: 'status',
          label: 'Situação',
          width: 'auto',
          formatter: Util.formatEmptyRow
        }
      ],
      abas: [
        {
          title: 'Municípios',
          value: 'MUNICIPIOS'
        },
        {
          title: 'Situação de Pagamento',
          value: 'SITUACAO_PAGAMENTO'
        },
        {
          title: 'Tipo de Processo',
          value: 'TIPO_CADASTRO'
        },
        {
          title: 'Período',
          value: 'PERIODO'
        }
      ]
    }
  },

  computed: {
    pagina () {
      return this.filtroProcessos.pagina + 1
    }
  },

  methods: {
    ...mapActions({
      getDadosCards: 'vtn/dadosCardsRelatorio',
      getDadosGrafico: 'vtn/dadosGraficoRelatorio',
      exportaCSVArrecadacao: 'relatoriosArrecadacao/exportaCSVArrecadacao',
      exportaCSVProcessosArrecadacao:
        'relatoriosArrecadacao/exportaCSVProcessosArrecadacao',
      resetLoader: 'loader/resetLoader',
      setLoader: 'loader/setLoader',
      getAllVtn: 'vtn/getAllVtn',
      findVtnByFilter: 'vtn/findVtnByFilter'
    }),

    async alterarGrafico (abaAtiva) {
      const tipo = this.switchValue ? 'AREA' : 'QUANTIDADE'
      this.tituloY = parametros.TIPO[tipo].tituloY
      this.tipoQuery = parametros.TIPO[tipo].tipoQuery
      this.parametroQuery = parametros[abaAtiva].parametroQuery
      this.tituloX = parametros[abaAtiva].tituloX
      this.abaAtiva = abaAtiva
      await this.findDadosGrafico()
    },

    async findDadosGrafico () {
      this.dadosGrafico = await this.getDadosGrafico({
        filtro: this.filtro,
        tipo: this.tipoQuery,
        parametro: this.parametroQuery,
        tipoData: this.tipoData
      })

      this.dadosGraficoTabela = _.cloneDeep(this.dadosGrafico)

      if (this.abaAtiva === 'TIPO_CADASTRO') {
        this.dadosGrafico.push({
          dadoNominal: 'Total de VTNs',
          dadoQuantitativo:
            this.dadosGrafico[0].dadoQuantitativo +
            this.dadosGrafico[1].dadoQuantitativo
        })
        this.dadosGraficoTabela = _.cloneDeep(this.dadosGrafico)
      }
      if (this.abaAtiva === 'PERIODO') {
        this.dadosGrafico.forEach((item) => {
          item.dadoNominal = item.dadoNominal[0].toUpperCase() + item.dadoNominal.substring(1)
        })
        this.dadosGraficoTabela = _.cloneDeep(this.dadosGrafico)
      }
      if (this.switchValue) {
        const format = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 })
        this.dadosGraficoTabela = this.dadosGraficoTabela.map((item) => {
          return { ...item, dadoQuantitativo: format.format(item.dadoQuantitativo) }
        })
      }
    },
    async filtrar (dados) {
      this.filtro = dados
      await this.findDadosGrafico()
    },

    async filtrarProcessos (dados) {
      this.filtroProcessos = dados
      await this.findVtnsCadastrados()
    },

    async limpar () {
      this.filtro = parametros.FILTRO_EMPTY
      await this.findDadosGrafico()
    },

    async limparProcessos (dados) {
      this.filtroProcessos = parametros.FILTRO_EMPTY
      await this.findVtnsCadastrados()
    },

    formatDate (data, formato) {
      return Util.formatDate(data, formato)
    },

    async exportar () {
      if (this.showGrafico) {
        this.setLoader()
        const that = this
        const exportDate = this.formatDate(new Date(), 'DD/MM/YYYY_HH:mm:ss')
        const blob = await domtoimage.toBlob(document.getElementById('sample'))
        window.saveAs(blob, 'Grafico_Arrecadação_' + exportDate + '.png')
        that.resetLoader()
      } else {
        const dados = {
          items: this.dadosGrafico,
          labelNominal: this.tituloX,
          labelQuantitativa: this.tituloY
        }
        this.exportaCSVArrecadacao(dados)
      }
    },

    async exportarProcessos () {
      this.exportaCSVProcessosArrecadacao(this.filtroProcessos)
    },

    async changeTipoData (tipo) {
      this.changeCorAbaPeriodo(this.tipoData, '#e9e9e9')
      this.tipoData = parametros.TIPO_DATA[tipo]
      this.tituloX = parametros.PERIODO.tituloX[this.tipoData]
      this.changeCorAbaPeriodo(this.tipoData, 'white')
      await this.findDadosGrafico()
      if (tipo === 'diario') {
        this.tituloX = 'Data'
      } else if (tipo === 'mensal') {
        this.tituloX = 'Mês'
      } else {
        this.tituloX = 'Ano'
      }
    },

    botoesAcao (processo) {
      return [
        {
          click: this.visualizarProcesso.bind(this, processo),
          icon: 'visibility',
          title: 'Visualizar',
          active: true
        }
      ]
    },

    visualizarProcesso (processo) {
      this.showModal = true
      this.idProcessoSelecionado = processo.id
    },

    async changePage (newPage) {
      this.filtroProcessos.pagina = newPage - 1
      await this.findVtnsCadastrados()
    },

    async findVtnsCadastrados () {
      const dados = await this.findVtnByFilter(this.filtroProcessos)
      this.processos = dados
      this.totalProcessos = 10
    },

    changeCorAbaPeriodo (aba, color) {
      document.getElementById(aba).style.backgroundColor = color
    },

    sortChanged ({ column, prop, order }) {
      if (order) {
        const direcaoMap = {
          ascending: 'ASC',
          descending: 'DESC'
        }
        this.filtroProcessos.ordem = prop
        this.filtroProcessos.ordemDirecao = direcaoMap[order]
      }

      this.findVtnsCadastrados()
    },

    formatValor (valor) {
      return valor ? valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : null
    }

  },

  async created () {
    document.title = 'SiCARF - Relatórios de VTN'
    this.dadosCards = await this.getDadosCards()
    await this.findVtnsCadastrados()
    await this.findDadosGrafico()
  },

  watch: {
    switchValue (val) {
      if (val) {
        this.switchText.texto = ' reais'
        this.alterarGrafico(this.abaAtiva, 'AREA')
      } else {
        this.switchText.texto = ' processos'
        this.switchText.template = '%{y}'
        this.alterarGrafico(this.abaAtiva, 'QUANTIDADE')
      }
    }
  }

}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/element-variables.scss';

.container {
  display: flex;
  width: 64%;
  min-height: 100%;
  gap: 4%;
}

#opcoes-periodo {
  background-color: #e9e9e9;
  height: 6vh;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  display: flex;
  align-items: center;
  color: black;
  gap: 0;
  width: 100%;

  .opcao-periodo {
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    width: 10%;
    cursor: pointer;
  }

  .opcao-periodo:hover {
    background-color: white;
  }

  .opcao-periodo:focus {
    background-color: white;
  }

  #month {
    background-color: white;
  }
}

#opcoes-periodo :first-child {
  border-top-left-radius: inherit;
}

.card-container {
  border-radius: 12px;
}

.titulo {
  color: $--color-primary;
  margin-top: 3px;
}

el-radio-group {
  position: absolute;
  top: -3vh;
  z-index: 1;
  left: 42%;
}

.table {
  width: 100%;
}

.button {
  display: flex;
  justify-content: flex-end;
}

.container-grafico {
  background-color: #f8f8f8;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  padding: 0.2% 1.5%;
  gap: 4%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  h3 {
    font-weight: bold;
  }

  .container-switch {
    justify-content: center;
    gap: 2%;
    font-weight: bold;
    height: 10vh;
    align-items: center;
    margin-top: 3%;
  }

  #export-button {
    right: 0;
    position: absolute;
  }
}

.el-table__row td .cell {
  text-align: center !important;
}

.el-table th > .cell {
  text-align: center;
}

.el-table--fit {
  padding: 10px;
  height: 450px;
  border-radius: 12px;
}

.el-radio-group {
  position: absolute;
  top: -23px;
  left: 42%;
  z-index: 1;
}

.tableContainer {
  width: 100%;
  height: 430px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  background-color: white;
}

.el-table::before{
  content: none;
}

@media screen and (min-width: 1820px){
.container {
  width: 52%;
}
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/relatorios/Home.vue